import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Types for our database
export interface UserProfile {
  id: string
  email: string
  full_name?: string
  src?: string
  created_at: string
  updated_at: string
}

export interface SubscriptionStatus {
  user_id: string
  status: 'active' | 'expired' | 'suspended' | 'cancelled'
  expiry_date?: string
  plan: string
  price: number
  last_checked: string
}

export interface ParkingSearch {
  id: string
  user_id: string
  latitude: number
  longitude: number
  search_radius: number
  created_at: string
}

export interface UserFavorite {
  id: string
  user_id: string
  place_id: string
  name: string
  address: string
  latitude: number
  longitude: number
  created_at: string
}

export interface PaymentAuditLog {
  id: string
  user_id: string
  payment_id?: string
  psp_transaction_id?: string
  amount?: number
  currency?: string
  payment_status?: string
  session_id?: string
  ip_address?: string
  user_agent?: string
  three_ds_result?: any
  authorization_code?: string
  capture_status?: string
  created_at: string
  updated_at: string
}

export interface UserActivityLog {
  id: string
  user_id: string
  session_id?: string
  event_type: string
  ip_address?: string
  user_agent?: string
  payment_id?: string
  details?: any
  created_at: string
}

export interface CheckoutSnapshot {
  id: string
  user_id: string
  session_id?: string
  checkout_html?: string
  hash_sha256?: string
  terms_accepted: boolean
  created_at: string
}

export interface WebhookLog {
  id: string
  webhook_payload?: any
  headers?: any
  signature_verified: boolean
  payment_id?: string
  processed_at: string
}

export interface EmailNotification {
  id: string
  user_id: string
  email_type: string
  recipient_email?: string
  email_html?: string
  hash_sha256?: string
  sent_at: string
  delivery_status: string
}

export interface DeviceCorrelation {
  id: string
  user_id: string
  payment_id?: string
  payment_ip?: string
  payment_user_agent?: string
  activity_ip?: string
  activity_user_agent?: string
  correlation_score: number
  created_at: string
}

export interface ServerScreenshot {
  id: string
  user_id: string
  payment_id?: string
  page_url?: string
  screenshot_data?: string
  hash_sha256?: string
  created_at: string
}

export interface ParkedVehicle {
  id: string
  user_id: string
  latitude: number
  longitude: number
  address?: string
  parked_at: string
  ended_at?: string
  expires_at?: string
}

export interface UserLicensePlate {
  id: string
  user_id: string
  license_plate: string
  created_at: string
  updated_at: string
}
